import React from 'react';
import autoBind from 'react-autobind';
import { notyEmitter } from '../../lib/noty';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

const initialState = {
  open: false,
  message: '',
  options: {}
};

export default class ConfirmModal extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { ...initialState };
    this.notyEmitter = notyEmitter;
    this.notyEmitter.on('confirm', ({ message, options }) => {
      this.setState({ message, options, open: true });
    });
  }

  handleOnOk() {
    if (this.state.options.onOk) {
      this.state.options.onOk();
    }
    this.setState({ ...initialState });
  }

  handleOnCancel() {
    if (this.state.options.onCancel) {
      this.state.options.onCancel();
    }
    this.setState({ ...initialState });
  }

  render() {
    let actions = [
      <FlatButton label="Cancel" primary onClick={this.handleOnCancel} />
    ];
    if (!this.state.options.alert) {
      actions.push(
        <FlatButton label="Confirm" primary onClick={this.handleOnOk} />
      );
    }

    return (
      <div>
        <Dialog
          actions={actions}
          modal
          open={this.state.open}
          style={{ zIndex: 3000 }}
          contentStyle={{ width: 400 }}
        >
          {this.state.message}
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/index.jsx